module.exports = __webpack_public_path__ + "img/tips.95c4f1da.png";